import { render } from "./BaseTreeViewArticles.vue?vue&type=template&id=27647fd6&scoped=true"
import script from "./BaseTreeViewArticles.vue?vue&type=script&lang=js"
export * from "./BaseTreeViewArticles.vue?vue&type=script&lang=js"

import "./BaseTreeViewArticles.vue?vue&type=style&index=0&id=27647fd6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27647fd6"]])

export default __exports__